import script from "./BottomNavBar.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomNavBar.vue?vue&type=script&setup=true&lang=js"

import "./BottomNavBar.vue?vue&type=style&index=0&id=7e8a4484&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e8a4484"]])

export default __exports__